import DataManagementService from "./service/dataManagementService";
import override from "src/dectorators/override";
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import {Component, Prop} from 'vue-property-decorator'
import './dataManagement.less'
import {DataManagementDOI} from "./api/dataManagementApi";
import { createBEM, createNamespace } from 'src/util/bem';
import Tab from 'src/components/tab/tab';
import Button from 'src/types/iview/Button';
import alertDataManagementModal from './dataManagementModal';
import EnumStationType from 'src/enums/enumStationType';
let bem = createBEM('menu-btn');


@Component({name: 'data-management'})
export default class DataManagement extends BasicSearchPage<DataManagementService, DataManagementDOI.RowDataI, DataManagementDOI.QueryRowDataParamsI> {
    currentDataCategories: number | null = null;
    dataCategories: {name: string, value: number}[] = []
    
    @Prop({
        type: Boolean,
        default: false,
    })
    isModal!: boolean

    @override
    renderHead(h) {
        return (
            <div class={bem()}>
                <div class={bem('title')}>
                  资料管理
                  <Tab dataSource={this.dataCategories} v-model={this.currentDataCategories} isDataManagement={true} on-change={this.tabChange.bind(this)}></Tab>
                </div>
                <div class={bem('query-form')} style="float:right">
                     <Button class={createNamespace('mb5')} type="primary" style="float:right" on-click={this.upload.bind(this)}>上传</Button>
                </div>
            </div>
        );
    }

    async created () {
        await this.service.queryDataCategories()
	}
    
	@override
	loadService () {
		this.service = new DataManagementService(this)
	}

    tabChange(value){
        this.currentDataCategories = value
        this.service.searchTable()
    }

    async upload() {
        let res = await alertDataManagementModal(EnumStationType.findCode(this.$route.params.type).getId());
        if (res) {
            this.service.searchTable()
        }
    }
}